"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeStyles = void 0;
var core_1 = require("@emotion/core");
var theme_1 = require("../theme");
var typeStyles = {
    h1: {
        fontSize: theme_1.theme.fontSizes.h1,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h1,
    },
    h2: {
        fontSize: theme_1.theme.fontSizes.h2,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h2,
    },
    h3: {
        fontSize: theme_1.theme.fontSizes.h3,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h3,
    },
    h4: {
        fontSize: theme_1.theme.fontSizes.h4,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h4,
    },
    h5: {
        fontSize: theme_1.theme.fontSizes.h5,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h5,
    },
    h6: {
        fontSize: theme_1.theme.fontSizes.h6,
        fontWeight: theme_1.theme.fontWeights.semiBold,
        lineHeight: theme_1.theme.lineHeights.h6,
    },
    body: {
        fontSize: theme_1.theme.fontSizes.body,
        fontWeight: theme_1.theme.fontWeights.regular,
        lineHeight: theme_1.theme.lineHeights.body,
    },
    small: {
        fontSize: theme_1.theme.fontSizes.small,
        fontWeight: theme_1.theme.fontWeights.regular,
        lineHeight: theme_1.theme.lineHeights.small,
    },
    mini: {
        fontSize: theme_1.theme.fontSizes.mini,
        fontWeight: theme_1.theme.fontWeights.regular,
        lineHeight: theme_1.theme.lineHeights.mini,
    },
};
var getTypeStyles = function (typeLevel, fontWeight, color) {
    if (typeLevel === void 0) { typeLevel = 'body'; }
    var styles = typeStyles[typeLevel];
    return (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    color: ", ";\n  "], ["\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    color: ", ";\n  "])), styles.fontSize, fontWeight
        ? theme_1.theme.fontWeights[fontWeight]
        : styles.fontWeight, styles.lineHeight, color ? theme_1.theme.colors[color] : theme_1.theme.colors.n900);
};
exports.getTypeStyles = getTypeStyles;
var templateObject_1;
//# sourceMappingURL=typeStyles.js.map